import React from "react";
import CacheDashboard from "../../components/CacheDashboard";
import * as CacheDashboardActions from "../../store/actions/CacheDashboard";

const App = () => {
    return (
        <div>
            <CacheDashboard getCache={CacheDashboardActions.getCache} setCache={CacheDashboardActions.setCache} deleteCache={CacheDashboardActions.deleteCache}/>
        </div>
    );
};

export default App;